<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'
import { faCopyright } from '@fortawesome/duotone-regular-svg-icons'
import Button from '~/components/ui/Button.vue'
import AuPopover from '~/components/ui/AuPopover.vue'

const props = defineProps<{
  copyright: string | undefined
  isAnimation?: boolean
}>()

const { t } = useI18n()

const copyrightText = computed(() => props.isAnimation
  ? t('copyright.animation', { copyright: props.copyright })
  : t('copyright.image', { copyright: props.copyright }))
</script>

<template>
  <div v-if="copyright" class="z-2">
    <AuPopover side="top" align="end">
      <template #trigger>
        <Button
          shape="square"
          size="sm"
          class="pointer-events-auto bg-(--theme-50,var(--color-green-50)) hover:not-disabled:bg-(--theme-60,var(--color-green-60))"
          :aria-label="t('media.showCopyright')"
        >
          <font-awesome-icon :icon="faCopyright" size="lg" />
        </Button>
      </template>
      <template #content>
        <p
          class="w-max max-w-[40ch] bg-white px-2 text-black"
          v-text="copyrightText"
        />
      </template>
    </AuPopover>
  </div>
</template>
